import { jsx, jsxs } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { IconLlmPaperclip } from '@websolutespa/bom-mixer-icons';
import style from './file.module.scss.js';

const File = props => {
  const {
    item
  } = props;
  const classNames = getClassNames(style.root, 'llm__file', {
    [`llm__file--${item.type}`]: !!item.type
  });
  const title = item.url && item.url.split('/').pop().split('?')[0];
  return jsx("div", {
    className: classNames,
    children: item.url ? jsx("div", {
      className: "llm__row",
      children: jsx("div", {
        className: "llm__col --end-xs-12 --xs-10 --sm-9 --md-8 --lg-7 --xl-6",
        children: jsxs("a", {
          className: style.anchor,
          href: item.url,
          download: title,
          target: "_blank",
          rel: "noreferrer",
          children: [jsx(IconLlmPaperclip, {
            className: style.icon
          }), " ", jsx("span", {
            children: title
          })]
        })
      })
    }) : jsx("pre", {
      className: classNames,
      children: JSON.stringify(item, null, 2)
    })
  });
};

export { File };
//# sourceMappingURL=file.js.map
